export const calcOrder = (page: number, perPage: number, index: number): number => {
    return (page - 1) * perPage + index + 1;
};